import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './_reducers';
import { createWS } from './_middleware';


// redux-logger has been removed. Its middleware was already gated on
// NODE_ENV, but `import { createLogger }` and the `createLogger()` call were
// both at module scope, so the bundler pulled the library into the production
// build regardless. The Redux DevTools extension covers the same need without
// shipping bytes to users.
const ws = createWS();
const middleware = [thunk, ws];


export const store = createStore(
	rootReducer,
	applyMiddleware(...middleware)
);